import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_HOST = process.env.REACT_APP_API_URL;

const CreateBlogger = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Authentication check - redirect if not logged in as blogHead
  useEffect(() => {
    const authToken = sessionStorage.getItem("authToken");
    const userType = sessionStorage.getItem("userType");
    
    if (!authToken) {
      navigate("/blogHead/login");
      return;
    }
    
    if (userType !== "blogHead") {
      // Redirect non-blogHead users to their appropriate page
      if (userType === "blogger") {
        navigate("/blogger");
      } else if (userType === "admin") {
        navigate("/admin/admin-dashboard");
      } else {
        navigate("/blogHead/login");
      }
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !password) {
      alert("Please fill all fields");
      return;
    }

    if (password.length < 6) {
      alert("Password must be at least 6 characters");
      return;
    }

    setIsSubmitting(true);
    const authToken = sessionStorage.getItem("authToken");
    
    // Double-check token before API call
    if (!authToken) {
      alert("Session expired. Please login again.");
      navigate("/blogHead/login");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axios.post(
        `${API_HOST}blogs2/createBloggerForBlogHead`,
        { name, email, password },
        {
          headers: {
            "auth-token": authToken,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        alert("Blogger created successfully!");
        navigate("/blogHead/blogs");
      }
    } catch (error) {
      console.error("Error creating blogger:", error);
      alert(error.response?.data?.error || "Failed to create blogger. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ padding: "40px 20px", maxWidth: "600px" }}>
      <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Create New Blogger</h1>
        <button onClick={() => navigate("/blogHead/blogs")} className="logout-button">
          Back
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter blogger name"
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              border: "1px solid #555",
              color: "#fff",
              backgroundColor: "#2a2a2a"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Email <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email address"
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              border: "1px solid #555",
              color: "#fff",
              backgroundColor: "#2a2a2a"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Password <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password (min 6 characters)"
            minLength={6}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              borderRadius: "4px",
              border: "1px solid #555",
              color: "#fff",
              backgroundColor: "#2a2a2a"
            }}
            required
          />
          <small>Password must be at least 6 characters</small>
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
          <button
            type="submit"
            disabled={isSubmitting}
            className="logout-button"
            style={{ flex: 1 }}
          >
            {isSubmitting ? "Creating..." : "Create Blogger"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/blogHead/blogs")}
            className="logout-button"
            style={{ flex: 1, background: "#6c757d" }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateBlogger;
